import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import AuthClassicLayout from "src/layouts/auth/classic";

// ----------------------------------------------------------------------

// JWT
const LoginPage = lazy(() => import("src/pages/auth/login"));

// ----------------------------------------------------------------------

export const authRoutes = [
  {
    path: "auth",
    element: (
      <Suspense>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        path: "login",
        element: (
          <AuthClassicLayout>
            <LoginPage />
          </AuthClassicLayout>
        ),
      },
    ],
  },
];
